enum ComplexTextAlign {
  Original = 'o',
  Left = 'l',
  Right = 'r',
  Center = 'c',
}

enum ComplexTextSizeUnit {
  AbsolutePixels = 'abs_px',
  RelativePixels = 'rel_px',
}

enum ComplexTextStyle {
  Original = 'original',
  Normal = 'normal',
  Italic = 'italic',
}

export {ComplexTextAlign, ComplexTextSizeUnit, ComplexTextStyle};
